import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Paper,
  Grid,
} from "@material-ui/core";
import PageTitle from "../../components/PageTitle/PageTitle";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import ApiConfig, { url } from "../../config/ApiConfig";
import Axios from "axios";
import axios from "axios";
import { toast } from "react-toastify";

const UserRecord = () => {
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState("");
  const [ticketData, setTicketData] = useState(null);
  const location = useLocation();
  //   const { ticketData } = location.state || {};

  console.log("szfkasklfhaslhfashfafhasklf", ticketData);

  const user = {
    ticketId: "12345",
    userName: "John Doe",
    email: "john.doe@example.com",
    issueDescription: "Unable to login to the account.",
    status: "Open",
    createdDate: "2023-10-01",
  };

  useEffect(() => {
    // Retrieve the ticket data from localStorage
    const storedTicketData = JSON.parse(localStorage.getItem("ticketData"));
    if (storedTicketData) {
      setTicketData(storedTicketData);
      console.log("Stored Ticket Data:", storedTicketData);
    }
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  //   const handleSubmit = () => {
  //     console.log("Response submitted:", response);
  //     setOpen(false);
  //   };

  const handleSubmit = async () => {
    try {
      const uniqueTicketId = ticketData.uniqueTicketId; // Get the uniqueTicketId from the ticket data
      const comment = response; // Get the comment from the response field

      console.log("gajdhsgjkahgjkhasjkgahsdjk", comment);

      // Make the API call
      const res = await axios({
        method: "put",
        url: `${url}/${uniqueTicketId}/update-status?status=${`COMPLETED`}`,
        data: { comment: comment },
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
      });

      console.log("gajdhsgjkahgjkhasjkgahsdjk", res.data);

      if (res.data.status == 200) {
        // localStorage.setItem("ticketData", JSON.stringify(res.data.data));
        setTicketData(res.data.data);
        setOpen(false); // Close the dialog
        setResponse("");
      } else {
        toast.error(
          res.data.message || "Something went wrong. Please try again."
        );
        setOpen(false); // Close the dialog
        setResponse("");
      }
    } catch (error) {
      console.error("Error submitting response:", error.response.data);
    }
  };

  return (
    <>
      <PageTitle title="Raised Ticket Details" />
      <Paper style={{ padding: "20px", margin: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Ticket ID:</strong>{" "}
              {ticketData && ticketData.uniqueTicketId}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Test Name:</strong> {ticketData && ticketData.testName}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Reason:</strong> {ticketData && ticketData.reason}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Description:</strong> {ticketData && ticketData.customReason || "-"}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Status:</strong> {ticketData && ticketData.status}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Created Date:</strong>{" "}
              {ticketData &&
                `${moment(ticketData.createdAt).format("MM/DD/YYYY")} ${moment(
                  ticketData.createdAt
                ).format("hh:mm:ss A")}`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Location:</strong>{" "}
              {(ticketData && ticketData.location) || "N/A"}
            </Typography>
          </Grid>

          {ticketData && ticketData.status === "COMPLETED" && (
            <Grid item xs={12}>
              <Typography variant="body1">
                <strong>Admin Response:</strong>{" "}
                {(ticketData &&
                  ticketData.comment &&
                  JSON.parse(ticketData.comment).comment) ||
                  "N/A"}
              </Typography>
            </Grid>
          )}
        </Grid>
        {ticketData && ticketData.status === "PENDING" && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleClickOpen}
            style={{ marginTop: "20px" }}
          >
            Respond
          </Button>
        )}

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth="sm" // Increase the width of the dialog
          fullWidth // Ensure the dialog takes up the full width allowed by maxWidth
        >
          <DialogTitle id="form-dialog-title">Respond to Ticket</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="response"
              label="Your Response"
              type="text"
              fullWidth
              multiline
              rows={4}
              value={response}
              onChange={(e) => setResponse(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSubmit} color="primary">
              Submit Response
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </>
  );
};

export default UserRecord;
